import React from "react";

const WhyChooseBizwit = () => {
  const features = [
    { id: "01", title: "Data-Driven Decision Making" },
    { id: "02", title: "Customizable Reports" },
    { id: "03", title: "Real-Time Insights" },
    { id: "04", title: "Industry Expertise" },
  ];

  return (
    <section className="p-8 bg-white">
      <div className="font-poppins">
        <h2 className="text-4xl font-bold mb-4">Why Choose Bizwit?</h2>
        <p className="text-gray-600 mb-10">
          Bizwit delivers customizable KPI dashboards, providing real-time,
          actionable insights that help businesses make informed decisions. With
          deep industry expertise, Bizwit supports growth by optimizing
          performance based on consumer behavior and market trends.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="flex items-center bg-gray-800 text-white p-6 shadow-md"
            >
              <div className="bg-pink text-white font-bold rounded-lg h-12 w-12 flex items-center justify-center mr-4">
                {feature.id}
              </div>
              <span className="text-lg font-medium">{feature.title}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseBizwit;
